module.exports = __webpack_public_path__ + "static/media/storybook_video.089e40bf.png";